class Schedule {

    static emptyHour() {
        return {raw: {}};
    }

    static makeHoursFromRaw(hours) {
        return hours.map(this.makeHourFromRaw).filter(hour => hour.length === 7);
    }

    static makeHourFromRaw(hour) {
        return `${hour.raw.hh}:${hour.raw.mm}${hour.raw.a}`;
    }

    static makeRawHours(hours) {
        return hours.map(this.makeRawHour).filter(hour => hour !== null);
    }

    static makeRawHour(hour) {
        // format: hh:mma
        // example: 03:14pm
        if (hour.length !== 7) return null;

        return {raw: {
            hh: hour.substring(0, 2),
            mm: hour.substring(3, 5),
            a : hour.substring(5, 7),
        }};
    }

    static makeRawHoursByDays(hoursByDays) {
        var initial = [
            {dayOfWeek: 1, label: 'Monday', hours: Schedule.makeRawHours([])},
            {dayOfWeek: 2, label: 'Tuesday', hours: Schedule.makeRawHours([])},
            {dayOfWeek: 3, label: 'Wednesday', hours: Schedule.makeRawHours([])},
            {dayOfWeek: 4, label: 'Thursday', hours: Schedule.makeRawHours([])},
            {dayOfWeek: 5, label: 'Friday', hours: Schedule.makeRawHours([])},
            {dayOfWeek: 6, label: 'Saturday', hours: Schedule.makeRawHours([])},
            {dayOfWeek: 7, label: 'Sunday', hours: Schedule.makeRawHours([])},
        ];


        hoursByDays.forEach(day => {
            let index = _.findIndex(initial, {dayOfWeek: day.day_of_week});

            initial[index].hours = this.makeRawHours(day.hours);
        });

        return initial;
    }
}

export default Schedule;
